import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import Card from "./card";

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import "./style.scss";
import { rules } from "eslint-config-prettier";
import { buildURLForMenuItem } from "../../utils/buildURL";
import { HomePadding } from "../HomePadding";

const CardSlider = ({ data }) => {
  const [active, setActive] = useState(0);
  const touchStart = useRef(0);
  const creditCardSlider = useRef(null);
  const reactSlickSlider = useRef(null);
  const TRANSITION = 1;

  useEffect(() => {
    let target = null;
    Array.from(document.getElementsByClassName("slick-current")).forEach(
      (elem) => {
        if (elem.closest(".cards-slider__holder") != null) {
          target = elem;
          return;
        }
      }
    );

    target.previousSibling &&
      target.previousSibling.classList.add("prev-slide");
    target.nextSibling && target.nextSibling.classList.add("next-slide");
  }, []);

  const onMouseDown = (e) => {
    touchStart.current = e.clientX;
    creditCardSlider.current.addEventListener("mousemove", onMouseMove);
  };

  const onPrevClick = () => {
    reactSlickSlider.current.innerSlider.slickPrev();
  };

  const onNextClick = () => {
    reactSlickSlider.current.innerSlider.slickNext();
  };

  const onMouseUp = (e) => {
    creditCardSlider.current.removeEventListener("mousemove", onMouseMove);

    if (touchStart.current - e.clientX > TRANSITION) {
      reactSlickSlider.current.innerSlider.slickNext();
    } else if (touchStart.current - e.clientX < -TRANSITION) {
      reactSlickSlider.current.innerSlider.slickPrev();
    }
  };

  const onMouseMove = (e) => {
    if (Math.abs(touchStart.current - e.clientX) > TRANSITION) {
      removePrevAndNextClasses();
    }
  };

  const onMouseLeave = () => {
    creditCardSlider.current.removeEventListener("mousemove", onMouseMove);
  };

  const removePrevAndNextClasses = () => {
    const prevElements = document.getElementsByClassName("prev-slide");
    const nextElements = document.getElementsByClassName("next-slide");

    Array.from(prevElements).forEach((element) => {
      element.classList.remove("prev-slide");
    });

    Array.from(nextElements).forEach((element) => {
      element.classList.remove("next-slide");
    });
  };

  return (
    <HomePadding>
      <div className="wrapper">
        <div
          class="cards-slider__holder"
          ref={creditCardSlider}
          id="cards-slider__holder"
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseLeave}
          onTouchStart={onMouseDown}
          onTouchEnd={onMouseUp}
          onTouchMove={onMouseMove}
        >
          <Slider
            className="cards-slider"
            dots={true}
            ref={reactSlickSlider}
            useTransform={true}
            draggable={true}
            infinite={true}
            speed={1000}
            // autoplay={true}
            // autoplaySpeed={10000}
            cssEase={"ease-in-out"}
            beforeChange={(current, next) => {
              removePrevAndNextClasses();
              setActive(next);
            }}
            afterChange={() => {
              let target = null;
              Array.from(
                document.getElementsByClassName("slick-current")
              ).forEach((elem) => {
                if (elem.closest(".cards-slider__holder") != null) {
                  target = elem;
                  return;
                }
              });

              target.previousSibling.classList.add("prev-slide");
              target.nextSibling.classList.add("next-slide");
            }}
          >
            {data.map(
              (
                {
                  title,
                  link,
                  description,
                  image: { url },
                  features,
                  tags,
                  contactless,
                },
                idx
              ) => (
                <Card
                  key={idx}
                  cardFeatures={features}
                  cardImage={url}
                  cardTitle={title}
                  cardSubtitle={description}
                  route={buildURLForMenuItem(link)}
                  tags={tags}
                  index={idx}
                  active={active}
                  onPrevClick={onPrevClick}
                  onNextClick={onNextClick}
                  maxIndex={data.length - 1}
                  contactless={contactless}
                />
              )
            )}
          </Slider>
          <div className="cards-slider__holder-hexagon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="288"
              height="330"
              viewBox="0 0 288 330"
            >
              <path d="M125.5,289L0.36,216.75V72.25L125.5,0,250.64,72.25v144.5Z"></path>
            </svg>
          </div>
        </div>
      </div>
    </HomePadding>
  );
};

export default CardSlider;
